<template>
  <fragment>
    <Header v-if="idExist() && !is404()" :id="id" :szezonid="szezonid" :teams="teams" :gameType="gameType"
            :statistics="statistics" :matchdate="matchdate" :venue="venue" :competition="competition" :age="age"
            :gender="gender" :lastPeriod="lastPeriod" :items="timeline"/>
    <router-view v-if="idExist() || is404()" :id="id" :szezonid="szezonid" :teams="teams" :gameType="gameType"
                 :players="players" :playtime="playtime" :items="timeline" :statistics="statistics"/>
  </fragment>
</template>

<script>
// Components
import Header from './components/Header.vue';
import TimeFormatter from '@/TimeFormatter';
import io from "socket.io-client";
import axios from 'axios'

import dotenv from 'dotenv';

dotenv.config()

global.log = function (_data) {
  const url = window.location.href.toLowerCase();

  if (url.includes('dev') || url.includes('teszt') || url.includes('localhost')) {

    console.log(_data);
  }
};

if (process.env.VUE_APP_APPLICATION_ENV) {
  window.config = require('./config_' + process.env.VUE_APP_APPLICATION_ENV);
} else {
  window.config = require('./config');
}

const SOCKET_OPTS = {
  //transports: ['websocket'],            // kerüld a pollingot
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 100,
  reconnectionDelayMax: 8000,
  timeout: 20000,                       // CONNECT timeout (nem a ping/pong)
  withCredentials: false,                // ha szerveren CORS credentials true
  // path: '/socket.io/',               // ha Nginx/Ingress miatt eltér a path, itt egyezzen
  // forceNew: true,                    // ha izolálni akarod a socketet
  auth: {
    token: window.config.socket_token
  }
};

let hasEverConnected = false;
// JAVÍTÁS: lásd a socket.on("error", ...) kommentjét - hány egymást követő
// alkalommal próbálkoztunk újra egy szerver-oldali (jellemzően Mongo-)
// hiba után, mielőtt végső megoldásként oldal-újratöltéshez folyamodnánk.
let errorRetryCount = 0;

let socket = io.connect(`${window.config.socket_host}:${window.config.socket_port}`, {
  ...SOCKET_OPTS
});

window.vueio = socket;

export default {
  name: 'App',
  data: function () {
    return {
      gameType: 'TEREM',
      initDone: false,
      storedItems: [],
      passedPeriods: [],
      items: [],
      teams: {
        A: {},
        B: {},
      },
      players: {
        A: [],
        B: [],
      },
      statistics: {
        A: {},
        B: {},
      },
      periods: [],
      defaultStats: {
        defendedFailed: 0,
        defendedFailedPenalty: 0,
        defendedSuccess: 0,
        defendedSuccessPenalty: 0,
        gol: 0,
        blokkolt: 0,
        gol2p: 0,
        gol6m: 0,
        gol7m: 0,
        rontott: 0,
        rontott6m: 0,
        rontott7m: 0,
        vedett: 0,
        vedett6m: 0,
        vedett7m: 0,
        kapufa: 0,
        kapufa6m: 0,
        kapufa7m: 0,
        eladott: 0,
        technikai: 0,
        kiallitas: 0,
        sargalap: 0,
        piroslap: 0,
        keklap: 0,
        timeout: 0,
      },
      playtime: {},
      venue: '',
      competition: '',
      age: '',
      gender: '',
      matchdate: '',
      loaded: false,
      timeline: []
    }
  },
  components: {
    Header,
  },
  watch: {
    items: {
      handler() {
        this.recalculateTimeline();
      }
    }
  },
  created() {
    let self = this;

    if (!self.idExist() && !self.is404()) {
      self.$router.push({path: '/404_not_found'});
    }
  },
  mounted() {
    let self = this;

    if (!self.idExist() && !self.is404()) {
      self.$router.push({path: '/404_not_found'});
    } else if (!self.is404()) {
      if (self.joinRoom(0, self.id)) {
        self.getData();
        self.getMatchData();
      }

      socket.on("connect", () => {
        global.log("connected");

        if (hasEverConnected) {

          socket.emit(
              "requestRoomData",
              {room: `Merkozes_${self.szezonid}_${self.id}`},
              (res) => {
                if (!res?.ok) {
                  console.warn("requestRoomData failed", res?.error);
                } else {
                  global.log("requestRoomData ok");
                  // JAVÍTÁS: korábban ez feltétel nélkül, minden "connect"
                  // eseménynél lefutott (a requestRoomData ACK-ját meg sem
                  // várva) - egy tartósan ingadozó kapcsolatnál (sok connect,
                  // miközben a szerver Mongo-hibája még fennáll, l.
                  // socket.on("error", ...) lentebb) ez a socket.io saját
                  // reconnectjei minden alkalmával nullázhatta volna a hiba-
                  // számlálót, MIELŐTT az elérné az 5 próbálkozást és a végső
                  // oldal-újratöltéshez folyamodna - tehát pont a legrosszabb
                  // (tartós hiba) esetben késleltette volna a végső
                  // helyreállítást. Mostantól csak akkor nullázunk, ha a
                  // kérés TÉNYLEGESEN sikeres volt.
                  errorRetryCount = 0;
                }
              }
          );
        } else {
          hasEverConnected = true;
          errorRetryCount = 0;
        }
      });

      socket.on("disconnect", () => {
        global.log("disconnected");
      });

      // JAVÍTÁS: a szerver (live-score-socket `getRoomData`) egy Mongo-hiba
      // esetén (pl. a `digital-report-socket`-tel MEGOSZTOTT Mongo lassul/
      // elérhetetlen) egy egyedi "error" eseményt küld a kliensnek - erre
      // eddig SEHOL nem volt feliratkozás, tehát a kliens ezt egyszerűen
      // figyelmen kívül hagyta. Mivel maga a socket-kapcsolat eközben ÉLŐ
      // marad (csak a mögötte lévő Mongo-lekérdezés hibázik), a socket.io
      // saját automatikus reconnect-mechanizmusa sem indul el - a felület
      // észrevétlenül "beragadt" volna (pl. betöltésre várva, vagy egy
      // elavult eredménnyel), amíg a felhasználó kézzel újra nem tölti az
      // oldalt. Mostantól: néhány alkalommal (növekvő várakozással) magunk
      // is újrapróbáljuk a `requestRoomData`-t - ha ez SEM sikerül több
      // próbálkozás után sem, végső megoldásként (ugyanaz a minta, mint a
      // lenti "nodatafound" hiba-ágon) újratöltjük az oldalt, hogy a
      // felhasználó biztosan ne ragadjon be véglegesen.
      socket.on("error", (err) => {
        console.error('[socket] error a szervertől:', err);
        errorRetryCount++;

        if (errorRetryCount <= 5) {
          setTimeout(() => {
            socket.emit(
                "requestRoomData",
                {room: `Merkozes_${self.szezonid}_${self.id}`},
                (res) => {
                  if (res?.ok) {
                    errorRetryCount = 0;
                  } else {
                    console.warn("requestRoomData retry (error után) sikertelen", res?.error);
                  }
                }
            );
          }, Math.min(3000 * errorRetryCount, 15000));
        } else {
          console.error('[socket] ismételt hiba után oldal-újratöltés.');
          setTimeout(function () {
            window.location.reload();
          }, 5000);
        }
      });

      socket.on("nodatafound", () => {
        global.log('nodatafound');
        self.loaded = false;
        axios.get(window.config.api_url + '/public/api/v1/versenyek/digital-report/esemeny/' + self.id, {
          headers: {
            "MKSZ-AUTH": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxIiwiYXV0aG9yaXRpZXMiOltdLCJha3RpdlN6ZXJ2ZXpldElkIjoiMSIsImFrdGl2U3plcnZlemV0TmV2IjoiTUtTWiIsImlhdCI6MTc3NTgxNDY1MH0.6sfJYsN_phi8hR0FLcHuF4mTn2clPVvi7_ThB8Srjdv5DGibS9wz20JoW4z16qDYZHnUFsGPKv3MwA7kwciNdg"
          }
        }).then(function (response) {
          response.data.forEach(function (item) {
            self.newMatchEvent(JSON.parse(item.event));
          });
          self.loaded = true;
        }).catch((err) => {
          console.log(err);
          setTimeout(function () {
            window.location.reload()
          }, 60000);
          // self.$router.push({path: "/404_not_found"});
        });
      });
    }
  },
  methods: {
    idExist: function () {
      // @TODO JELENEG mivel a socketben nem feltétlen szám, hanem most string is lehet a meccs azonosító, ezért nem jó az isnan vizsgálat
      // return !isNaN(this.id) && this.id > 0;
      return typeof this.id !== 'undefined' && this.id !== '';
    },
    is404: function () {
      return this.$route.path === '/404_not_found';
    },
    joinRoom: function (szezonid, id) {
      return socket.emit("join", "Merkozes_" + szezonid + "_" + id);
    },
    getArrayObject(arr, key, value) {
      let rtn = false;

      arr.forEach(function (item) {
        if (!rtn && item[key] && item[key] === value) {
          rtn = item;
        }
      });

      return rtn;
    },
    getArrayIndex(arr, key, value) {
      let rtn = false;

      arr.forEach(function (item, index) {
        if (rtn === false && item[key] && item[key] === value) {
          rtn = index;
        }
      });

      return rtn;
    },
    /**
     * A csatlakozásig bekerült események
     */
    getMatchData: function () {
      let self = this;
      socket.on("matchdata", (data) => {
        // global.log('matchdata');
        return self.newMatchEvent(data);
      });
      self.loaded = true;
    },
    /**
     * Az új események
     */
    getData: function () {
      let self = this;
      socket.on("data", (data) => {
        return self.newMatchEvent(data);
      });
    },
    newMatchEvent: function (data) {
      // global.log('new match event');
      let self = this;
      let existIndex = self.getArrayIndex(self.items, 'UUID', data.UUID);

      if (!data.deleted) {
        if (existIndex === false) {
          self.addNewRow(data);
        } else {
          self.items = self.items.filter(function (item) {
            return data.UUID !== item.UUID;
          });
          self.addNewRow(data);
        }
      } else {
        if (data.deleted && existIndex !== false) {
          self.items = self.items.filter(function (item) {
            return data.UUID !== item.UUID;
          });
        }
      }
      return true;
    },
    addNewRow: function (data) {
      let self = this;

      if (data && data.action) {
        // global.log(data.action);
        switch (data.action) {
          case('periodchange'): {
            // global.log('periodchange');
            if (!self.initDone) {
              self.storedItems.push(data);
            } else {
              if (data.period !== '1') {
                let period = self.getArrayObject(self.periods, 'value', data.period);

                // JAVÍTÁS: korábban itt egy szigorú "ez legyen pontosan a következő,
                // még fel nem dolgozott periódus" ellenőrzés volt. Ha az 1. félidő
                // valamiért sosem került be a passedPeriods-ba (ld. 'gamedatachange'
                // ág, ami kapusváltás eseményhez kötött), ez az ellenőrzés örökre
                // meghiúsult minden KÉSŐBBI félidőváltásnál is, és csak a 'default'
                // ág tartalék logikája - az adott félidő ELSŐ eseményekor - pótolta be
                // utólag a félidő kezdetét. Mostantól a periódusváltás önmagában is
                // elég ahhoz, hogy azonnal megjelenjen, nem kell megvárni egy eseményt.
                if (period && !self.passedPeriods.includes(data.period)) {
                  self.passedPeriods.push(data.period);

                  self.items.push({
                    UUID: 'period_' + data.period,
                    clientTime: data.clientTime,
                    action: 'periodChange',
                    actionName: period.text + (['zero', 'extendedzero'].includes(period.type) ? '' : ' kezdete'),
                    gameTime: TimeFormatter.intToString(period.gameTime - (['zero', 'extendedzero'].includes(period.type) ? 0 : period.duration)),
                    period: data.period,
                  });
                }
              }
            }

            break;
          }
          case('init'): {
            // global.log('init');
            let periods = [];
            let periodSum = 0;

            if (data && data.params && data.params.periods) {
              
              // Sort periods chronologically before computing gameTime
              let isStrand = data.params.rule === 'STRAND';
              data.params.periods.sort((a, b) => self.getChronoOrder(a.value, isStrand) - self.getChronoOrder(b.value, isStrand));

              data.params.periods.forEach(function (period) {
                let periodLength = 0;

                if (!['zero', 'extendedzero'].includes(period.type)) {
                  periodLength = period.type === 'extended' ? 300 : data.params.period_length * 60;
                }

                if (period.value === '1') {
                  periodSum = 0;
                }

                periodSum += periodLength;

                periods.push({
                  ...period,
                  duration: periodLength,
                  gameTime: periodSum,
                });
              });

              if (data.params.rule === 'STRAND') {
                self.gameType = 'STRAND';
              } else {
                self.gameType = 'TEREM';
              }

              self.periods = periods;

              self.teams = {
                A: {
                  short: data.params.team_a_shortname,
                  full: data.params.team_a_name,
                  // logo: '/logo/tatabanya.png',
                  score: 0,
                },
                B: {
                  short: data.params.team_b_shortname,
                  full: data.params.team_b_name,
                  // logo: '/logo/szeged.png',
                  score: 0,
                },
              };

              if (data.params.team_a_name && data.params.team_b_name) {
                document.title = data.params.team_a_name + " - " + data.params.team_b_name + " | MKSZ élő mérkőzés közvetítés";
              } else if (data.params.team_a_shortname && data.params.team_b_shortname) {
                document.title = data.params.team_a_shortname + " - " + data.params.team_b_shortname + " | MKSZ élő mérkőzés közvetítés";
              }

              if (data.params.letesitmeny_nev) {
                self.venue = data.params.letesitmeny_nev;
              }

              if (data.params.alverseny) {
                self.competition = data.params.alverseny;
              }

              if (data.params.korosztaly) {
                self.age = data.params.korosztaly;
              }

              if (data.params.datum_teny && data.params.ido) {
                self.matchdate = data.params.datum_teny + ' ' + data.params.ido;
              }

              self.players = {
                A: [
                  ...self.buildPersons(data.params.team_a_players, 'player'),
                  ...self.buildPersons(data.params.team_a_officials, 'official'),
                  ...self.buildPersons(data.params.team_a_players_entry, 'entry'),
                ],
                B: [
                  ...self.buildPersons(data.params.team_b_players, 'player'),
                  ...self.buildPersons(data.params.team_b_officials, 'official'),
                  ...self.buildPersons(data.params.team_b_players_entry, 'entry'),
                ],
              };

              self.initDone = true;

              if (self.storedItems.length) {
                let tempStoredItems = [...self.storedItems];
                self.storedItems = [];

                tempStoredItems.forEach(function (item) {
                  self.addNewRow(item);
                });
              }
            }

            break;
          }
          case('player_entry'): {
            // global.log('player_entry');
            if (!self.initDone) {
              self.storedItems.push(data);
            } else {
              let team = data.params.player.team === "teamA" ? 'A' : 'B';
              let playerIndex = self.getArrayIndex(self.players[team], 'id', data.params.player.id);

              if (playerIndex !== false) {
                self.players[team][playerIndex].player = true;
                self.players[team][playerIndex].goalkeeper = Boolean(data.params.player.goalkeeper);
                self.players[team][playerIndex].entry = false;
              } else {
                self.players[team].push({
                  ...data.params.player,
                  player: true,
                  goalkeeper: Boolean(data.params.player.goalkeeper),
                  official: false,
                  entry: false,
                });
              }

              self.items.push({
                ...data,
                gameTime: '00:00'
              });
            }

            break;
          }
          case('gamedatachange'): {
            // global.log('gamedatachange');
            if (!self.initDone) {
              self.storedItems.push(data);
            } else {
              if (data.period && data.params && data.period === '1' && ["team_a_actual_goalkeeper", "team_b_actual_goalkeeper"].includes(data.params.name) && !self.passedPeriods.includes(data.period)) {
                if (self.gameType === 'TEREM' || data.params.gametime !== 0) {
                  self.passedPeriods.push(data.period);

                  self.items.push({
                    UUID: 'period_' + data.period,
                    clientTime: data.clientTime,
                    action: 'periodChange',
                    actionName: 'I. félidő kezdete',
                    gameTime: '00:00',
                    period: data.period,
                  });
                }
              }
            }

            break;
          }
          case('playtime'): {
            // global.log('playtime');
            self.playtime = data.params.playtime;
            break;
          }
          default:
            // global.log('default');
            if (!self.initDone) {
              self.storedItems.push(data);
            } else {
              let prevPeriodValue = self.prevPeriod(data.period);

              if (data.period && !self.passedPeriods.includes(prevPeriodValue)) {
                let period = self.getArrayObject(self.periods, 'value', prevPeriodValue);

                self.passedPeriods.push(prevPeriodValue);

                self.items.push({
                  UUID: 'period_' + period.value,
                  clientTime: data.clientTime,
                  action: 'periodChange',
                  actionName: period.text + (['zero', 'extendedzero'].includes(period.type) ? '' : ' kezdete'),
                  gameTime: TimeFormatter.intToString(period.gameTime - period.duration),
                  //gameTime: period.params.gameTime,
                  period: period.value,
                });
              }

              if (data.period && !self.passedPeriods.includes(data.period)) {
                let period = self.getArrayObject(self.periods, 'value', data.period);

                self.passedPeriods.push(data.period);

                self.items.push({
                  UUID: 'period_' + period.value,
                  clientTime: data.clientTime,
                  action: 'periodChange',
                  actionName: period.text + (['zero', 'extendedzero'].includes(period.type) ? '' : ' kezdete'),
                  gameTime: TimeFormatter.intToString(period.gameTime - period.duration),
                  //gameTime: period.params.gameTime,
                  period: period.value,
                });
              }

              let eventTotalSecs = data.totalGameTime;
              if (eventTotalSecs == null) {
                let periodObj = self.getArrayObject(self.periods, 'value', data.period);
                let periodOffset = periodObj ? periodObj.gameTime - periodObj.duration : 0;
                eventTotalSecs = periodOffset + (data.gametime || 0);
              }
              self.items.push({
                ...data,
                gameTime: TimeFormatter.intToString(eventTotalSecs)
              });
            }

            break;
        }
      }

      const uniqueArray = Array.from(new Map(self.items.map(item => [item.UUID, item])).values());
      // global.log(uniqueArray);
      self.items = uniqueArray;
    },
    prevPeriod: function (value) {
      let self = this;
      let found = false;
      let rtn = self.periods.length > 0 ? self.periods[0].value : '1';

      self.periods.forEach(function (period) {
        if (!found && period.value === value) {
          found = true;
        }

        if (!found) {
          rtn = period.value;
        }
      });

      return rtn;
    },
    buildPersons: function (persons, type) {
      let rtn = [];

      if (persons) {
        persons.forEach(function (person) {
          rtn.push({
            ...person,
            player: false,
            official: false,
            entry: false,
            [type]: true,
          });
        });
      }

      return rtn;
    },
    compareInc: function (a, b) {
      if (Number(a.period) === Number(b.period)) {
        let aTime = TimeFormatter.stringToInt(a.gameTime || '00:00');
        let bTime = TimeFormatter.stringToInt(b.gameTime || '00:00');
        
        if (aTime === bTime) {
          if (a.clientTime < b.clientTime) {
            return -1;
          }

          if (a.clientTime > b.clientTime) {
            return 1;
          }

          return 0;
        }

        if (aTime < bTime) {
          return -1;
        }

        if (aTime > bTime) {
          return 1;
        }

        return 0;
      }

      const isStrand = this.gameType === 'STRAND';
      if (this.getChronoOrder(a.period, isStrand) < this.getChronoOrder(b.period, isStrand)) {
        return -1;
      }
      if (this.getChronoOrder(a.period, isStrand) > this.getChronoOrder(b.period, isStrand)) {
        return 1;
      }
      return 0;
    },
    getChronoOrder: function (value) {
      if (value === null || value === undefined) return 0;
      let map = {
          '0': 0, '1': 1, '2': 3, '3': 4,
          '14': 5, '4': 6, '5': 7, '15': 8, '6': 9, '7': 10,
          '16': 11, '8': 12, '9': 13, '17': 14, '10': 15,
          '11': 16, '12': 98, '18': 17, '13': 99
      };
      return map[String(value)] !== undefined ? map[String(value)] : parseInt(value);
    },
    addStat: function (item) {
      let self = this;
      let invTeam = (item.team === 'A') ? 'B' : 'A';

      ['A', 'B'].forEach(function (team) {
        if (!self.statistics[team][item.period]) {
          self.statistics[team][item.period] = {...self.defaultStats};
        }
      });

      switch (item.action) {
        case('kiallitas'): {
          self.statistics[item.team][item.period].kiallitas++;
          break;
        }
        case('2perc'): {
          self.statistics[item.team][item.period].kiallitas++;
          break;
        }
        case('4perc'): {
          self.statistics[item.team][item.period].kiallitas += 2;
          break;
        }
        case('timeOut'): {
          self.statistics[item.team][item.period].timeout++;
          break;
        }
        default:
          self.statistics[item.team][item.period][item.action]++;

          switch (item.action) {
            case('gol'):
              self.statistics[invTeam][item.period].defendedFailed++;
              break;
            case('gol2p'):
              self.statistics[invTeam][item.period].defendedFailed++;
              break;
            case('gol6m'):
              self.statistics[invTeam][item.period].defendedFailedPenalty++;
              break;
            case('gol7m'):
              self.statistics[invTeam][item.period].defendedFailedPenalty++;
              break;
            case('vedett'):
              self.statistics[invTeam][item.period].defendedSuccess++;
              break;
            case('vedett6m'):
              self.statistics[invTeam][item.period].defendedSuccessPenalty++;
              break;
            case('vedett7m'):
              self.statistics[invTeam][item.period].defendedSuccessPenalty++;
              break;
          }

          break;
      }
    },
    addPlayerStat: function (item) {
      let self = this;
      let playerIndex = self.getArrayIndex(self.players[item.team], 'id', item.player.id);

      if (playerIndex === false) {
        return;
      }

      switch (item.action) {
        case('kiallitas'): {
          self.players[item.team][playerIndex].statistics.kiallitas++;
          break;
        }
        case('2perc'): {
          self.players[item.team][playerIndex].statistics.kiallitas++;
          break;
        }
        case('4perc'): {
          self.players[item.team][playerIndex].statistics.kiallitas += 2;
          break;
        }
        default:
          self.players[item.team][playerIndex].statistics[item.action]++;
          break;
      }
    },
    recalculateTimeline: function () {
      let self = this;
      let rtn = [];
      let period = '1';
      let szetlovesTime = false;
      let szetlovesPeriod = false;

      self.statistics = {
        A: {},
        B: {},
      };

      ['A', 'B'].forEach(function (team) {
        self.teams[team].score = 0;
        self.players[team].forEach(function (obj, index) {
          self.players[team][index].statistics = {...self.defaultStats};
        });
      });

      self.items.forEach(item => {
        if (item.actionName === 'Szétlövés') {
          szetlovesTime = item.gameTime;
          szetlovesPeriod = Number(item.period);
        }
      });

      // JAVÍTÁS: a periódusok időpontját az init a TELJES periódus-listából
      // számolja (l. addNewRow 'init' ága), a le nem játszott periódusokkal együtt.
      // Ha a mérkőzésen engedélyezve van a hosszabbítás, de nem kellett (a bíró a
      // II. félidőből egyenesen a "Mérkőzés vége"-re vált), a záró sor így a
      // hosszabbítás utáni ELMÉLETI időpontra került: 60 perces meccsnél 70:00-ra
      // (32021458662, 2026-09-27). A záró ('zero'/'extendedzero') sorok idejét
      // ezért a ténylegesen LEJÁTSZOTT periódusok közül a legkésőbbi végéhez
      // igazítjuk - azok számítanak lejátszottnak, amelyekhez van elem a
      // listában (esemény, vagy maga a periódus kezdete). Soha nem visszük az
      // elméleti idő fölé, így a normál esetben (pl. "Félidő" 30:00-kor) semmi
      // nem változik. A rendezést nem érinti: az elsődleges kulcs a periódus
      // sorrendje (compareInc). Csak TEREM szabálynál: a STRAND "Szétlövés" sor
      // idejét a szétlövés eseményei is használják (szetlovesTime), ahhoz nem
      // nyúlunk. Ugyanezt a CR-oldal (mksz-digital-report-v2
      // src/utils/periodStartat.js) már a ténylegesen elért periódusok alapján
      // számolja.
      let playedPeriodsEnd = 0;
      if (self.gameType === 'TEREM') {
        self.items.forEach(item => {
          let p = self.getArrayObject(self.periods, 'value', item.period);
          if (p && !['zero', 'extendedzero'].includes(p.type) && p.gameTime > playedPeriodsEnd) {
            playedPeriodsEnd = p.gameTime;
          }
        });
      }

      [...self.items].sort(self.compareInc).forEach(item => {
        if (self.gameType === 'STRAND' && period !== item.period) {
          period = item.period;
          self.teams['A'].score = 0;
          self.teams['B'].score = 0;
        }

        if (item.action === 'periodChange') {
          let displayGameTime = item.gameTime;
          if (playedPeriodsEnd > 0) {
            let p = self.getArrayObject(self.periods, 'value', item.period);
            if (p && ['zero', 'extendedzero'].includes(p.type) && p.gameTime > playedPeriodsEnd) {
              displayGameTime = TimeFormatter.intToString(playedPeriodsEnd);
            }
          }
          rtn.push({
            ...item,
            gameTime: displayGameTime,
            scores: item.actionName === 'Szétlövés' ? '0 : 0' : (item.actionName === 'Félidő' || item.actionName.includes('vége')) ? '' : self.teams['A'].score + ' : ' + self.teams['B'].score,
          });
        } else if (item.action === 'player_entry') {
          if (item.params.player.team) {
            rtn.push({
              UUID: item.UUID,
              clientTime: item.clientTime,
              action: item.action,
              actionName: "Játékos benevezés",
              gameTime: '00:00',
              scores: self.teams['A'].score + ' : ' + self.teams['B'].score,
              team: item.params.player.team.slice(item.params.player.team.length - 1),
              period: item.period,
              selectedArea: null,
              selectedGateArea: 0,
              player: {
                id: item.params.player.id,
                jersey: item.params.player.jersey,
                name: item.params.player.name,
              }
            });
          }
        } else if (item.usertype === 'sub') {
          // Ez a cseréről jön, ezzel nem csinálunk semmit
        } else {
          if (item.params && item.params.selectedTeamId) {
            let team = item.params.selectedTeamId.slice(item.params.selectedTeamId.length - 1);

            if (['gol', 'gol7m'].includes(item.action)) {
              self.teams[team].score++;
            }

            if (item.action === 'gol2p' || item.action === 'gol6m') {
              self.teams[team].score += 2;
            }

            /*
            self.teams['A'].score = item.params.teamScore.teamA;
            self.teams['B'].score = item.params.teamScore.teamB;
            */

            let row = {
              UUID: item.UUID,
              clientTime: item.clientTime,
              action: item.action,
              actionName: item.params.selectedAction.actionName,
              approved: item.params.approved,
              rejected: item.params.rejectReason,
              gameTime: (szetlovesPeriod && szetlovesTime && szetlovesPeriod <= Number(item.period)) ? szetlovesTime : item.gameTime,
              scores: self.teams['A'].score + ' : ' + self.teams['B'].score,
              team: team,
              period: item.period,
              selectedArea: item.params.selectedArea,
              selectedGateArea: item.params.selectedGateArea,
              shotType: item.params.selectedActionType ? item.params.selectedActionType : null,
              player: {
                id: 0,
                jersey: '',
                name: '',
              }
            };

            if (item.params.selectedPlayer) {
              let player = self.getArrayObject(self.players[team], 'id', item.params.selectedPlayer);

              //Direkt van így!
              if (player !== false) {
                row.player = {
                  id: player.id,
                  jersey: player.jersey,
                  name: player.name,
                };
              }
            }

            if (['gol', 'gol2p', 'gol6m', 'gol7m', 'vedett', 'vedett6m', 'vedett7m'].includes(item.action)) {
              let invTeam = (team === 'A') ? 'B' : 'A';

              if (item.params.otherTeamGoalKeeper && item.params.otherTeamGoalKeeper.id) {
                let goalkeeperIndex = self.getArrayIndex(self.players[invTeam], 'id', item.params.otherTeamGoalKeeper.id);

                if (goalkeeperIndex !== false) {
                  let goalkeeper = self.players[invTeam][goalkeeperIndex];

                  row.defended = {
                    id: goalkeeper.id,
                    jersey: goalkeeper.jersey,
                    name: goalkeeper.name,
                  };

                  switch (item.action) {
                    case('gol'):
                      self.players[invTeam][goalkeeperIndex].statistics.defendedFailed++;
                      break;
                    case('gol2p'):
                      self.players[invTeam][goalkeeperIndex].statistics.defendedFailed++;
                      break;
                    case('gol6m'):
                      self.players[invTeam][goalkeeperIndex].statistics.defendedFailedPenalty++;
                      break;
                    case('gol7m'):
                      self.players[invTeam][goalkeeperIndex].statistics.defendedFailedPenalty++;
                      break;
                    case('vedett'):
                      self.players[invTeam][goalkeeperIndex].statistics.defendedSuccess++;
                      break;
                    case('vedett6m'):
                      self.players[invTeam][goalkeeperIndex].statistics.defendedSuccessPenalty++;
                      break;
                    case('vedett7m'):
                      self.players[invTeam][goalkeeperIndex].statistics.defendedSuccessPenalty++;
                      break;
                  }
                }
              } else {
                row.defended = {
                  id: 0,
                  jersey: '',
                  name: 'Üres kapu',
                };
              }
            }

            if (item.action !== 'timeOut' || item.params.type !== 'lost') {
              rtn.push(row);
              self.addStat(row);
            }

            if (item.action !== 'timeOut') {
              self.addPlayerStat(row);
            }
          }
        }
      });

      self.timeline = rtn;
    }
  },
  computed: {
    id: function () {
      if (this.$router.history &&
          this.$router.history.current &&
          this.$router.history.current.params &&
          this.$router.history.current.params.id
      ) {
        return this.$router.history.current.params.id;
      }

      return undefined;
    },
    szezonid: function () {
      return "0";
    },
    lastPeriod: function () {
      if (this.passedPeriods.length) {
        return this.passedPeriods[this.passedPeriods.length - 1];
      }

      return '0';
    }
  }
}
</script>

<style>
html body {
  color: #000000;
  background-color: #f0f3f6;
  position: relative;
  z-index: 1;
}

a, a:hover, a:focus, a:active, a:visited {
  text-decoration: none !important;
  outline: none !important;
}

*:focus {
  outline: none !important;
}

body:before {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;

  background-image: url('/image/gray-bg-left.png');
  background-size: contain;
  background-position: top left;
  background-repeat: no-repeat;

  max-width: 831px;
  max-height: 841px;

  width: 50vw;
  height: 841px;
}

body:after {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;

  background-image: url('/image/gray-bg-right.png');
  background-size: contain;
  background-position: top right;
  background-repeat: no-repeat;

  max-width: 883px;
  max-height: 861px;

  width: 50vw;
  height: 861px;
}

.main-container {
  background-color: #ffffff;
  padding: 35px 75px 50px 75px;
  margin-bottom: 25px;
}

.modal-header .close {
  font-size: 30px !important;
  padding: 10px !important;
  line-height: 30px !important;
  margin: 0 0 0 auto !important;
}

.modal-header {
  display: flex !important;
  flex-flow: row !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  flex-wrap: nowrap !important;
  padding: 0 15px !important;
}

.modal-body {
  padding: 15px !important;
}

.itemsEmpty {
  text-align: center;
  width: 100%;
  height: 50px;
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.tooltip-inner {
  white-space: nowrap;
  max-width: none !important;
}

@media screen and (max-width: 992px) {
  .main-container {
    padding: 25px 10px 25px 10px;
  }
}

@media screen and (max-width: 600px) {
  .container-lg {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .container-lg > .row {
    margin-left: -10px !important;
    margin-right: -10px !important;
  }

  .modal-header {
    padding: 0 10px !important;
  }

  .modal-body {
    padding: 10px !important;
  }
}
</style>
